import React from "react";

const SearchIcon = ({ className }) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.2501 12.75L9.7167 10.2166M9.7167 10.2166C10.1501 9.78323 10.4938 9.26877 10.7283 8.70257C10.9629 8.13637 11.0836 7.52952 11.0836 6.91666C11.0836 6.30381 10.9629 5.69696 10.7283 5.13076C10.4938 4.56456 10.1501 4.0501 9.7167 3.61675C9.28335 3.1834 8.76889 2.83964 8.20269 2.60512C7.63649 2.37059 7.02964 2.24988 6.41679 2.24988C5.80394 2.24988 5.19709 2.37059 4.63088 2.60512C4.06468 2.83964 3.55022 3.1834 3.11687 3.61675C2.24168 4.49194 1.75 5.67896 1.75 6.91666C1.75 8.15437 2.24168 9.34139 3.11687 10.2166C3.99206 11.0918 5.17908 11.5835 6.41679 11.5835C7.6545 11.5835 8.84151 11.0918 9.7167 10.2166Z"
        stroke="#80828B"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;
